import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

class ModalDeleteImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    toggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    onDelete = () => {
        const { order, onDelete } = this.props;
        this.toggle();
        if (onDelete) onDelete(order);
    }

    render() {
        return (
            <div>
                <Button
                    color="primary"
                    className="position-absolute ui-image-delete-button"
                    onClick={this.toggle}
                >
                    <i className="fa fa-lg fa-trash-o"></i>
                </Button>
                <Modal isOpen={this.state.isOpen} toggle={this.toggle} className="ui-paradigma-modal modal-danger">
                    <ModalHeader toggle={this.toggle}>Eliminar imagen</ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Confirmación</p>
                            <p className="ui-inline-message">¿Está seguro que desea eliminar esta imagen?</p>
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancelar</Button>
                        <Button color="danger" onClick={this.onDelete}>Eliminar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalDeleteImages;



// WEBPACK FOOTER //
// ./src/views/Loteos/ModalDeleteImages.js